import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'; 

// Import Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from './components/ScrollToTop'; 
import ContactButton from './components/ContactButton';

// Import Pages
import Home from './pages/Home';
import Vehicles from './pages/Vehicles';
import Details from './pages/Details'; 
import About from './pages/About';
import Contact from './pages/Contact';
import Auth from './pages/Auth/Auth'; 
import Dashboard from './pages/Dashboard';

// Main App Component that uses hooks
function App() {
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  return (
    <>
      <ScrollToTop /> 
      <div className="min-h-screen bg-slate-950 text-white flex flex-col">
        <Navbar />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/details/:id" element={<Details />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            
            <Route path="/login" element={<Auth />} /> 
            <Route path="/signup" element={<Auth />} />
            
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </main>

        {/* CONDITIONAL RENDER: Hide ContactButton and Footer on Dashboard */}
        {!isDashboard && <ContactButton />}
        {!isDashboard && <Footer />} 
      </div>
    </>
  );
}

const Root = () => (
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

export default Root;